import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

const availableTitles = ["Oops!", "Oh no!", "Hmmm..."];

export default function FnrErrorMessage({ errors = [], message }) {
  if (message && errors.length === 0) errors = [message];

  const title = availableTitles[0];

  return (
    <AnimatePresence>
      {errors.length > 0 && (
        <Wrapper
          key="message"
          initial={{ height: 0, opacity: 0, scale: 0.8 }}
          animate={{ height: "auto", opacity: 1, scale: 1 }}
          exit={{
            height: 0,
            opacity: 0,

            scale: 0.6,
            transition: { type: "tween" },
          }}
        >
          <Padding />
          <MessageContainer>
            <Title data-cy="errorMsgTitle">
              <TitleIcon className="far fa-tired" />
              {title}
            </Title>
            {errors.map((errorMessage, index) => (
              <Message key={errorMessage}>
                <MessageInside data-cy="errorMsgBody">
                  {errorMessage}
                </MessageInside>
              </Message>
            ))}
          </MessageContainer>
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  z-index: 1;
  overflow: hidden;
`;
const Padding = styled.div`
  height: 14px;
`;
const MessageContainer = styled.div`
  background: #f7f0b6;
  color: #d5a223;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.1em;
  padding: 8px 16px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: inset rgba(0, 0, 0, 0.2) 0 1px 5px;
`;

const Message = styled(motion.div)`
  overflow: hidden;
  margin-top: -1px;
`;
const MessageInside = styled.div`
  padding: 8px 0;
  padding-bottom: 9px;
  font-size: 18px;
  line-height: 1.2em;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const TitleIcon = styled.div`
  margin-right: 12px;
`;
